import { render, staticRenderFns } from "./ProcessExceptionsEdit.vue?vue&type=template&id=10b3c688"
import script from "./ProcessExceptionsEdit.vue?vue&type=script&lang=js"
export * from "./ProcessExceptionsEdit.vue?vue&type=script&lang=js"
import style0 from "./ProcessExceptionsEdit.vue?vue&type=style&index=0&id=10b3c688&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports